import { render, staticRenderFns } from "./VehicleErrorCard.vue?vue&type=template&id=1caf53c2&scoped=true"
import script from "./VehicleErrorCard.vue?vue&type=script&lang=js"
export * from "./VehicleErrorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caf53c2",
  null
  
)

export default component.exports